import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation("common");

  const allItems: BreadcrumbItem[] = [
    { label: t("breadcrumb.home"), to: "/" },
    ...items,
  ];

  const schemaData = {
    itemListElement: allItems.map((item, index) => ({
      "@type": "ListItem" as const,
      position: index + 1,
      item: {
        "@id": item.to ? `https://www.51baoliao.com${item.to}` : undefined,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            ...schemaData,
          }),
        }}
      />
      <nav aria-label="Breadcrumb" className="py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {allItems.map((item, index) => {
            const isLast = index === allItems.length - 1;
            return (
              <li key={index} className="flex items-center gap-1.5">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                )}
                {isLast || !item.to ? (
                  <span className="text-foreground-500 font-label">{item.label}</span>
                ) : (
                  <Link
                    to={item.to}
                    className="text-secondary-500 hover:text-secondary-700 transition-colors font-label cursor-pointer"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}